import React, { createContext, forwardRef } from 'react';
import Kefir from 'kefir';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var SiltContext = createContext(null);
var Provider = SiltContext.Provider,
    Consumer = SiltContext.Consumer;

var RootJunction =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RootJunction, _React$Component);

  function RootJunction() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RootJunction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RootJunction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "root$", Kefir.pool());

    _defineProperty(_assertThisInitialized(_this), "sub", void 0);

    return _this;
  }

  _createClass(RootJunction, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.sub = this.props.root$(this.root$);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.root$ !== prevProps.root$) {
        this.sub && this.sub.unsubscribe();
        this.sub = this.props.root$(this.root$);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.sub && this.sub.unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Provider, {
        value: this.root$
      }, this.props.children);
    }
  }]);

  return RootJunction;
}(React.Component);

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports(interopRequireDefault);

var getDisplayName_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports["default"] = _default;
});

unwrapExports(getDisplayName_1);

var wrapDisplayName_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports["default"] = void 0;

var _getDisplayName = interopRequireDefault(getDisplayName_1);

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName["default"])(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports["default"] = _default;
});

var wrapDisplayName = unwrapExports(wrapDisplayName_1);

var id = function id(x) {
  return x;
};

function toJunction(events) {
  var combine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id;
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(ToJunction, _React$Component);

      function ToJunction(props) {
        var _this;

        _classCallCheck(this, ToJunction);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ToJunction).call(this, props));

        _defineProperty(_assertThisInitialized(_this), "root$", void 0);

        _defineProperty(_assertThisInitialized(_this), "events", void 0);

        _defineProperty(_assertThisInitialized(_this), "sources", void 0);

        _defineProperty(_assertThisInitialized(_this), "children$", void 0);

        _defineProperty(_assertThisInitialized(_this), "source$", void 0);

        _this.root$ = null;
        _this.events = {};
        _this.children$ = Kefir.pool();
        _this.sources = {
          list: [_this.children$],
          dict: {
            children$: _this.children$
          },
          merged: Kefir.never()
        };

        var _loop = function _loop(_key) {
          var e$ = new Kefir.Stream();

          _this.events[_key] = function (e) {
            e$._emitValue(e);
          };

          _this.sources.list.push(_this.sources.dict[_key + '$'] = events[_key](e$));
        };

        for (var _key in events) {
          _loop(_key);
        }

        _this.sources.merged = Kefir.merge(_this.sources.list);
        _this.source$ = _this.createSource();
        return _this;
      }

      _createClass(ToJunction, [{
        key: "createSource",
        value: function createSource() {
          var combined$ = combine(this.sources.merged, this.sources.dict, this.props);

          if (this.props.preplug) {
            return this.props.preplug(combined$);
          }

          return combined$;
        }
      }, {
        key: "unplug",
        value: function unplug() {
          this.root$ && this.root$.unplug(this.source$);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unplug();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.unplug();
          this.root$ && this.root$.plug(this.source$ = this.createSource());
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          return React.createElement(Consumer, null, function (root$) {
            if (root$ != null) {
              if (_this2.root$ !== root$) {
                _this2.unplug();

                _this2.root$ = root$.plug(_this2.source$);
              }
            } else {
              console.error('Used `toJunction` outside of Silt context. Needs to be wrapped in `<RootJunction>`');
            }

            var props = _objectSpread({}, _this2.props, {}, _this2.events);

            return React.createElement(Provider, {
              value: _this2.children$
            }, React.createElement(WrappedComponent, props));
          });
        }
      }]);

      return ToJunction;
    }(React.Component), _defineProperty(_class, "displayName", wrapDisplayName(WrappedComponent, 'ToJunction')), _temp;
  };
}

var isRefForwarding = function isRefForwarding(x) {
  return typeof x === 'function' && x.length === 2;
};

var wrap = function wrap(WrappedComponent) {
  if (isRefForwarding(WrappedComponent)) {
    return forwardRef(WrappedComponent);
  }

  return WrappedComponent;
};

var withRef$ = function withRef$(refback) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(WithRef$, _React$Component);

      function WithRef$() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, WithRef$);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithRef$)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "props$", new Kefir.Stream().toProperty(function () {
          return _this.props;
        }).setName("".concat(WithRef$.displayName, "#props$")));

        _defineProperty(_assertThisInitialized(_this), "ref$", new Kefir.Property().setName("".concat(WithRef$.displayName, "#ref$")));

        _defineProperty(_assertThisInitialized(_this), "aggregated$", void 0);

        _defineProperty(_assertThisInitialized(_this), "plugged$", void 0);

        _defineProperty(_assertThisInitialized(_this), "refback", function (el) {
          return el && _this.ref$._emitValue(el);
        });

        return _this;
      }

      _createClass(WithRef$, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.aggregated$ && this.plugged$ && this.aggregated$.unplug(this.plugged$);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.emitProps();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.emitProps();
        }
      }, {
        key: "emitProps",
        value: function emitProps() {
          this.props$._emitValue(this.props);
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          return React.createElement(Consumer, null, function (aggregated$) {
            if (aggregated$ != null) {
              if (_this2.plugged$ && _this2.aggregated$ !== aggregated$) {
                _this2.aggregated$ && _this2.aggregated$.unplug(_this2.plugged$);
                _this2.aggregated$ = aggregated$.plug(_this2.plugged$);
              }

              if (!_this2.plugged$) {
                _this2.aggregated$ = aggregated$.plug(_this2.plugged$ = refback(_this2.ref$, _this2.props$));
              }
            } else {
              console.error('Used `withRef$` outside of Silt context. Needs to be wrapped in `<RootJunction>`');
            }

            return React.createElement(WithRef$.Target, _extends({}, _this2.props, {
              ref: _this2.refback
            }));
          });
        }
      }]);

      return WithRef$;
    }(React.Component), _defineProperty(_class, "displayName", wrapDisplayName(WrappedComponent, 'WithRef$')), _defineProperty(_class, "Target", wrap(WrappedComponent)), _temp;
  };
};

export { RootJunction, toJunction, withRef$ };
